import { useTranslation } from "react-i18next";
import { Alert, AlertAction, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

export function BillingSkeleton() {
  return (
    <section className="rounded-[var(--r-lg)] border border-[var(--border)] bg-[var(--card)] p-6 shadow-[var(--sh-xs)]">
      <div className="animate-pulse space-y-4">
        <div className="h-6 bg-muted rounded w-1/3"></div>
        <div className="h-4 bg-muted rounded w-2/3"></div>
        <div className="h-32 bg-muted rounded"></div>
      </div>
    </section>
  );
}

interface BillingErrorStateProps {
  error: string | null;
  onRetry: () => Promise<void>;
}

export function BillingErrorState({ error, onRetry }: BillingErrorStateProps) {
  const { t } = useTranslation(["billing"]);
  return (
    <section className="space-y-4 rounded-[var(--r-lg)] border border-[var(--border)] bg-[var(--card)] p-6 shadow-[var(--sh-xs)]">
      <h2 className="text-lg font-semibold text-foreground">{t("billing:title")}</h2>
      <Alert variant="error">
        <AlertDescription className="flex-1">{error}</AlertDescription>
        <AlertAction>
          <Button
            data-test="billing-retry"
            onClick={onRetry}
            size="sm"
            variant="outline"
          >
            {t("billing:retry")}
          </Button>
        </AlertAction>
      </Alert>
    </section>
  );
}

export function BillingHeader({ isAdminTopUpMode }: { isAdminTopUpMode: boolean }) {
  const { t } = useTranslation(["billing"]);

  return (
    <div>
      <h2 className="text-lg font-semibold text-[var(--foreground)]">
        {isAdminTopUpMode ? t("billing:status.title") : t("billing:title")}
      </h2>
      <p className="text-sm text-[var(--muted-foreground)]">
        {isAdminTopUpMode
          ? t("billing:adminTopUp.subtitle")
          : t("billing:subtitle")}
      </p>
    </div>
  );
}
